module.exports = __webpack_public_path__ + "static/media/oracle.892312f4.png";